// extracted by mini-css-extract-plugin
module.exports = {"tagInput":"TagInputEditor_tagInput__oeEAN","filterInput":"TagInputEditor_filterInput__3dU-K"};